// ** Reactstrap Imports
import {
  Badge,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input
} from 'reactstrap';
import { Star, MoreVertical, Trash2, Edit2, FileText, Copy } from 'react-feather';
import { makeUniqueId } from '@apollo/client/utilities';

// ** Renders Role Columns
const renderType = (row) => {
  const typeColor = {
    FREE: {
      primary: '#14E4ED',
      secondary: '#E8FEFF',
      text: 'Free'
    },
    PREMIUM: {
      primary: '#7139F0',
      secondary: '#EFE8FF',
      text: 'Premium'
    },
    FREEMIUM: {
      primary: '#14E4ED',
      secondary: '#FFEBF9',
      text: 'Freemium'
    }
  };

  const Div = () => (
    <div
      style={{
        color: typeColor[row.membership].primary,
        background: `${typeColor[row.membership].secondary
          } 0% 0% no-repeat padding-box`,
        padding: '2.5px 16px',
        borderRadius: '11px',
        fontWeight: 'bold'
      }}
    >
      {typeColor[row.membership].text}
    </div>
  );

  return (
    <span className="text-left">
      <Div />
    </span>
  );
};

const renderStars = (row) => {
  const q = Array(parseInt(row.rate)).fill();
  const rest = Array(parseInt(5 - q.length)).fill();

  return (
    <span>
      {q.map(() => (
        <Star
          key={makeUniqueId(Date.now())}
          style={{
            marginRight: 4
          }}
          size={15}
          color="#FFCB3C"
          fill="#FFCB3C"
        />
      ))}
      {rest.map(() => (
        <Star
          key={makeUniqueId(Date.now())}
          style={{
            marginRight: 4
          }}
          size={15}
          color="#B9B9C3"
          fill="#B9B9C3"
        />
      ))}
    </span>
  );
};

const statusObj = {
  active: 'light-success',
  inactive: 'light-secondary'
};

export const columns = ({ handleDelete, handleUpdateNew, navigate, getChallenge, duplicateRoad }) => [
  {
    name: 'PORTADA',
    sortable: false,
    minWidth: '110px',
    selector: (row) => row.cover,
    cell: (row) => {
      return (<>
        {row.challenge && <Star style={{ position: 'absolute', left: '3px' }} size={14} className="me-50" color="#FFCB3C" />}
        <img width={45} height={45} src={row.cover} />
      </>);
    }
  },
  {
    name: 'NOMBRE',
    sortable: true,
    minWidth: '200px',
    sortField: 'name',
    selector: (row) => row.name,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        <div className="d-flex flex-column">
          <span className="fw-bolder">{row.name}</span>
        </div>
      </div>
    )
  },
  {
    name: 'EMPEZADOS',
    minWidth: '160px',
    sortable: true,
    sortField: 'started',
    selector: (row) => row.started,
    cell: (row) => <span className="text-capitalize">{row.started}</span>
  },
  {
    name: 'PORCENTAJE',
    minWidth: '150px',
    sortable: false,
    selector: (row) => row.started,
    cell: (row) => (
      <div className="progress" style={{ width: '100%', height: 7 }}>
        <div
          id={row._id}
          className="progress-bar"
          role="progressbar"
          style={{
            background: '#4DFF84',
            width: row.started ? `${(row.finished / row.started) * 100}%` : '0%'
          }}
          aria-valuenow={row.started || 0}
          aria-valuemin={0}
          aria-valuemax={100}
        ></div>
      </div>
    )
  },

  {
    name: 'COMPLETADOS',
    minWidth: '168px',
    sortable: true,
    sortField: 'finished',
    selector: (row) => row.finished,
    cell: (row) => <span className="text-capitalize">{row.finished}</span>
  },
  {
    name: 'CALIFICACION',
    sortable: true,
    minWidth: '172px',
    sortField: 'role',
    selector: (row) => row.membership,
    cell: (row) => renderStars(row)
  },
  {
    name: 'MEMBRESIA',
    sortable: true,
    minWidth: '150px',
    sortField: 'role',
    selector: (row) => row.membership,
    cell: (row) => renderType(row)
  },
  {
    name: 'Estado',
    minWidth: '100px',
    sortable: false,
    sortField: 'status',
    selector: (row) => row.status,
    cell: (row) => (
      <Badge
        className="text-capitalize"
        color={row.status ? statusObj.active : statusObj.inactive}
        pill
      >
        {row.status ? 'Activo' : row.draf ? 'Borrador' : 'Inactivo'}
      </Badge>
    )
  },
  {
    name: '',
    minWidth: '20px',
    sortable: false,
    cell: (row) => (
      <div className="column-action">
        <UncontrolledDropdown>
          <DropdownToggle tag="div" className="btn btn-sm">
            <MoreVertical size={14} className="cursor-pointer" />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              tag="a"
              href="/"
              className="w-100"
              onClick={(e) => {
                e.preventDefault();
                navigate(`/roads/details/${row._id}`);
              }}
            >
              <FileText size={14} className="me-50" />
              <span className="align-middle">Detalles</span>
            </DropdownItem>
            <DropdownItem
              tag="a"
              href="/"
              className="w-100"
              onClick={(e) => {
                e.preventDefault();
                navigate(`/roads/edit/${row._id}`);
              }}
            >
              <Edit2 size={14} className="me-50" />
              <span className="align-middle">Editar</span>
            </DropdownItem>
            <DropdownItem
              tag="button"
              className="w-100"
              onClick={() => handleDelete(row._id)}
            >
              <Trash2 size={14} className="me-50" />
              <span className="align-middle">Eliminar</span>
            </DropdownItem>
            <DropdownItem
              tag="button"
              className="w-100"
              onClick={() => getChallenge(row)}
            >
              <Star size={14} className="me-50" />
              <span className="align-middle">Challenge</span>
            </DropdownItem>
            <DropdownItem
              tag="button"
              className="w-100"
              onClick={() => duplicateRoad(row)}
            >
              <Copy size={14} className="me-50" />
              <span className="align-middle">Duplicar</span>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    )
  },
  {
    id: makeUniqueId(),
    name: 'NUEVO',
    minWidth: '95px',
    selector: (row) => row.new,
    cell: (row) => (
      <div className="form-switch form-check-primary">
        <Input
          type="checkbox"
          id={`${row._id}_checked_type`}
          name="primary"
          style={{
            cursor: 'pointer'
          }}
          onChange={(e) => handleUpdateNew(e.target.checked, row._id)}
          defaultChecked={row.new}
        />
      </div>
    )
  }
];
